export const MFE_AGENT_UI = {
	headerTitleKey: 'mfe_agent_ui.header.title',
	headerSubtitleKey: 'mfe_agent_ui.header.subtitle',
	headerCloseAriaKey: 'mfe_agent_ui.header.close_aria_label',
	headerNewChatAriaKey: 'mfe_agent_ui.header.new_chat_aria_label',
	headerContainerModeAriaKey: 'mfe_agent_ui.header.container_mode_aria_label',
	headerContainerModeFloatingKey: 'mfe_agent_ui.header.container_mode.floating',
	headerContainerModeSidebarKey: 'mfe_agent_ui.header.container_mode.sidebar',
	headerContainerModeFullScreenKey: 'mfe_agent_ui.header.container_mode.full_screen',
	bubbleAriaKey: 'mfe_agent_ui.bubble.aria_label',
	suggestionsHeadingKey: 'mfe_agent_ui.suggestions.heading',
	composerPlaceholderKey: 'mfe_agent_ui.composer.placeholder',
	composerSendAriaKey: 'mfe_agent_ui.composer.send_aria_label',
	composerStopAriaKey: 'mfe_agent_ui.composer.stop_aria_label',
	reasoningWorkingKey: 'mfe_agent_ui.reasoning.working',
	reasoningCompletedStepsKey: 'mfe_agent_ui.reasoning.completed_steps',
	reasoningToggleAriaKey: 'mfe_agent_ui.reasoning.toggle_aria',
	serviceResponseStoppedKey: 'mfe_agent_ui.service.response_stopped',
	serviceGenericErrorKey: 'mfe_agent_ui.service.generic_error',
	serviceBusyErrorKey: 'mfe_agent_ui.service.busy_error',
	genuiConfirmCancelKey: 'mfe_agent_ui.genui.confirm.cancel_label',
	genuiConfirmConfirmKey: 'mfe_agent_ui.genui.confirm.confirm_label',
	genuiConfirmConfirmedKey: 'mfe_agent_ui.genui.confirm.confirmed',
	genuiConfirmCanceledKey: 'mfe_agent_ui.genui.confirm.canceled',
	genuiFormSubmittedKey: 'mfe_agent_ui.genui.form.submitted',
	courseCardClickEvent: 'mfe-agent-ui:course-card-click',
	feedbackLikeAriaKey: 'mfe_agent_ui.feedback.like_aria_label',
	feedbackDislikeAriaKey: 'mfe_agent_ui.feedback.dislike_aria_label',
	feedbackMoreActionsAriaKey: 'mfe_agent_ui.feedback.more_actions_aria_label',
	feedbackMenuCopyKey: 'mfe_agent_ui.feedback.menu.copy_response',
	feedbackMenuLeaveKey: 'mfe_agent_ui.feedback.menu.leave_feedback',
	feedbackMenuRetryKey: 'mfe_agent_ui.feedback.menu.retry',
	feedbackFormTitleKey: 'mfe_agent_ui.feedback.form.title',
	feedbackFormSubtitlePositiveKey: 'mfe_agent_ui.feedback.form.subtitle_positive',
	feedbackFormSubtitleNegativeKey: 'mfe_agent_ui.feedback.form.subtitle_negative',
	feedbackFormCloseAriaKey: 'mfe_agent_ui.feedback.form.close_aria_label',
	feedbackFormCategoryAccurateKey: 'mfe_agent_ui.feedback.form.category.accurate',
	feedbackFormCategoryHelpfulKey: 'mfe_agent_ui.feedback.form.category.helpful',
	feedbackFormCategoryRelevantKey: 'mfe_agent_ui.feedback.form.category.relevant',
	feedbackFormCategoryInaccurateKey: 'mfe_agent_ui.feedback.form.category.inaccurate',
	feedbackFormCategoryUnhelpfulKey: 'mfe_agent_ui.feedback.form.category.unhelpful',
	feedbackFormCategoryIrrelevantKey: 'mfe_agent_ui.feedback.form.category.irrelevant',
	feedbackFormCategoryOtherKey: 'mfe_agent_ui.feedback.form.category.other',
	feedbackFormTextareaPlaceholderKey: 'mfe_agent_ui.feedback.form.textarea_placeholder',
	feedbackFormTextareaLabelKey: 'mfe_agent_ui.feedback.form.textarea_label',
	feedbackFormSubmitKey: 'mfe_agent_ui.feedback.form.submit',
	feedbackFormMissingCategoryErrorKey: 'mfe_agent_ui.feedback.form.missing_category_error',
	feedbackFormMissingFeedbackErrorKey: 'mfe_agent_ui.feedback.form.missing_feedback_error',
	feedbackBannerSuccessKey: 'mfe_agent_ui.feedback.banner.success_message',
	feedbackBannerDismissAriaKey: 'mfe_agent_ui.feedback.banner.dismiss_aria_label'
} as const;
